var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"clearfix mb-0 footer-text"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Nirvana Memorial Garden Pte. Ltd. ")])}
var staticRenderFns = []

export { render, staticRenderFns }